import { notification } from 'antd';
import { useMutation } from 'react-query';
import { getQuestReportHourlyCost } from './HourlyCost.service';
import reportNotificationError from '@/utils/functions/notificationErrorNetReport';

export function useHourlyCostReport() {
  return useMutation(getQuestReportHourlyCost, {
    onSuccess() {
      notification.success({
        message: 'Relatório custo da hora foi gerado com sucesso!',
      });
    },

    onError(error) {
      reportNotificationError(error);
    },
  });
}
